import { render, staticRenderFns } from "./chooseNormal.vue?vue&type=template&id=47eb89b9&scoped=true&"
import script from "./chooseNormal.vue?vue&type=script&lang=js&"
export * from "./chooseNormal.vue?vue&type=script&lang=js&"
import style0 from "./chooseNormal.vue?vue&type=style&index=0&id=47eb89b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.8.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47eb89b9",
  null
  
)

export default component.exports